// Legal copy is an additional element that's not a part of the general 'tabs' functionality
const legalCopyTransitionClass = 'specs-home__legal-copy--transition';
const legalCopy = document.querySelector('.specs-home__legal-copy');

export default class SpecsTabbedContent{
  constructor(tabEventListener, tabContent, activeTabClass, activeTabContentClass){
    this.tabEventListener = document.querySelectorAll(tabEventListener);
    this.tabContent = document.querySelectorAll(tabContent);
    this.activeTabClass = activeTabClass;
    this.activeTabContentClass = activeTabContentClass;
  }

  initEventListeners(){
    this.tabEventListener.forEach( (e) => {
      e.addEventListener('click', (event) => {
        const tabData = e.getAttribute('data-tab');
        const tabContent = document.querySelector(`[data-tab-accordion-content="${tabData}"]`);

        // If they click on the tab again while it's already active, do nothing
        if (e.classList.contains(this.activeTabClass)) event.preventDefault();
        else {
          // Close all, only one can be open
          this.closeAll();
          // Activates current clicked tab
          e.classList.add(this.activeTabClass);

          // Transition for legal copy and opens the current tab content
          // Need for the current tab content and legal copy to open at the same time or else the legal copy bounces to the top
          legalCopy.classList.add(legalCopyTransitionClass);
          tabContent.classList.add(this.activeTabContentClass);

          // Wait a bit to remove the transition class
          setTimeout( () => {
            legalCopy.classList.remove(legalCopyTransitionClass);
          }, 100);
        }
      });
    });
  }

  closeAll(){
    this.tabEventListener.forEach( (e) => {
      e.classList.remove(this.activeTabClass);
    });
    this.tabContent.forEach( (e) => {
      e.classList.remove(this.activeTabContentClass);
    });
  }

  showTabContent(index){
    this.tabEventListener[index].classList.add(this.activeTabClass);
    this.tabContent[index].classList.add(this.activeTabContentClass);
  }
}
